<template>
    <span v-b-popover.hover.top="requestDateLabel">
        <base-button :disabled="shouldDisable || buttonDisabled || !partnerNationId" size="sm" :aria-label="requestDateLabel" @click="requestSignature()"
            class="btn-dark"> 
                <i class="tim-icons icon-send"></i> 
                REQUEST SIGNATURE
            </base-button>
    </span>
</template>

<script>
import { BaseButton } from "@/components";
import Util from "@/util/util";
import moment from "moment";
import { mapGetters } from "vuex";

export default {
    components: {
        BaseButton
    },
   
    name: "request-signature",
    props: {
        moduleSubmit: {
            type: Function
        },
        signatureUrl: {
            type: String,
            default: "",
        },
        reload: {
            type: Function
        },
        requestDate: {
            type: String,
            default: null,
        },
        isDisabled: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return{
          dateLabel: 'Request Signature',
        responseDate : null,
        buttonDisabled: false
        }
    } ,
    computed: {
        ...mapGetters({
            partnerNationId: "orderMetadata/partnerNationId",
        }),
        requestDateLabel() {
          return  Util.isNullOrEmpty(this.requestDate ? this.requestDate : this.responseDate) ? `Request Signature` :
                `${moment(this.requestDate ? this.requestDate : this.responseDate).format("DD-MMMM-YYYY h:mm a")}`
        },
        shouldDisable() {
            return this.isDisabled;
        }
    },
    watch: {
        requestDate(newValue) {
            this.dateLabel = this.requestDateLabel
        },
      
    },

    methods: {
        async requestSignature() {
            this.buttonDisabled = true;
            await this.moduleSubmit();
            await this.save();
        },
        async save() {
            //send the notification
            try {
                let response = await this.axios.get(this.signatureUrl);
               this.responseDate = response.data 
                this.$emit('update-status');
                this.$toast.success( "Success: Your requst was successfully sent!");

            }
            catch (err) {
                this.$toast.error(err.message);
            this.buttonDisabled = false;

            }
           
        }
    }
};
</script>
<style></style>
